// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type {
    GetAsrFilterConfigAsrEngineByLanguageTypeParam,
    BaseResponseListAsrManager,
} from '../../../../types';

/**
 * 获取当前语言的可用ASR引擎
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [GET] /asr-filter-config/asr/engine/{languageType}
 * @param languageType
 */
export function getAsrFilterConfigAsrEngineByLanguageType(
    options: ApiOptions<GetAsrFilterConfigAsrEngineByLanguageTypeParam, never> & {
        segments: GetAsrFilterConfigAsrEngineByLanguageTypeParam;
    }
): Promise<BaseResponseListAsrManager> {
    return request<never, GetAsrFilterConfigAsrEngineByLanguageTypeParam, never>(
        '/asr-filter-config/asr/engine/{languageType}',
        {
            ...options,
            method: 'get',
            __$requestCalleeName: 'getAsrFilterConfigAsrEngineByLanguageType',
        }
    );
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/asr/engine/{languageType}',
        method: 'get',
    },
];
